import { type PortfolioSymbolType } from "#/types/markets";

export enum TxStatus {
  IDLE = "idle",
  PENDING = "pending",
  SUCCESS = "success",
  ERROR = "error",
}

export interface TxState {
  status: TxStatus;
  txHash?: string;
  amount?: number;
  fromPortfolio?: PortfolioSymbolType;
  toPortfolio?: PortfolioSymbolType;
}

export type TxModalVariant = "deposit" | "withdraw" | "transfer";
